"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CloudArrowUp: function() {
        return CloudArrowUp;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const CloudArrowUp = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 4C9.51785 4 7.45643 5.80967 7.0665 8.18158C6.99268 8.63058 6.62505 8.97314 6.17196 9.0151C4.39329 9.17984 3 10.6778 3 12.5C3 14.0224 3.97251 15.3201 5.33325 15.8011C5.85396 15.9851 6.12689 16.5565 5.94284 17.0772C5.75879 17.5979 5.18747 17.8708 4.66675 17.6868C2.53192 16.9322 1 14.8963 1 12.5C1 9.8925 2.8139 7.70961 5.24923 7.14303C6.0632 4.17816 8.7764 2 12 2C15.866 2 19 5.13401 19 9C19 9.00916 19 9.01831 18.9999 9.02746C21.2499 9.27616 23 11.1837 23 13.5C23 15.7679 21.3233 17.6424 19.1416 17.9545C18.5949 18.0327 18.0883 17.6529 18.0101 17.1062C17.9319 16.5594 18.3117 16.0528 18.8584 15.9746C20.069 15.8015 21 14.7586 21 13.5C21 12.1193 19.8807 11 18.5 11C18.3549 11 18.2134 11.0123 18.0763 11.0356C17.7556 11.0902 17.4285 10.9854 17.1992 10.7547C16.9699 10.5241 16.8672 10.1963 16.9237 9.876C16.9738 9.59225 17 9.2996 17 9C17 6.23858 14.7614 4 12 4ZM8.29289 13.2929L11.2929 10.2929C11.6834 9.90237 12.3166 9.90237 12.7071 10.2929L15.7071 13.2929C16.0976 13.6834 16.0976 14.3166 15.7071 14.7071C15.3166 15.0976 14.6834 15.0976 14.2929 14.7071L13 13.4142V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V13.4142L9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071C7.90237 14.3166 7.90237 13.6834 8.29289 13.2929Z",
        fill: "currentColor"
    })
}), "CloudArrowUp");
const _default = CloudArrowUp;
